import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "./components/shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";

import { AmbifiWebPlayer } from "./lib/index";
import { getConfigParam } from "./utils/config";
import { handleLaunchInNewTab } from "./utils/utils";
import { isPublished } from "./utils/utils";

import "./utils/fontawesome";

// import {setActivities} from './actions/actions.js';

class App extends PureComponent {

	constructor(props) {
		super(props);

		this.state = {
			transitionPlayOverlay: false,
			hidePlayOverlay: false,
			showSubmissionPage: false
		};
		autoBind(this);
	}

	handleHidePlayOverlay() {
		this.setState({
			transitionPlayOverlay: true
		});
		setTimeout(() => {
			this.setState({
				hidePlayOverlay: true
			});
		}, 1000);
	}

	handleOpenInNewTab() {
		handleLaunchInNewTab();
	}

	handleWebPlayerOnLoad() {
		// console.log("Web player loaded");
		global.exiting = false;
	}

	handleWebPlayerOnExit() {
		// console.log("Web player exited");
		global.exiting = true;
		window.close();

		if (isPublished()) {
			this.setState({
				showSubmissionPage: true
			});
		}
	}

	render() {
		// alert(getIframeAttribute("hello"))
		//if (!this.props.activityName) {
		//	return (
		//			<div style={{ margin: "25px" }}>
		//			<h1>Loading...</h1>
		//		</div>
		//	);
		//} else {

		if (this.state.showSubmissionPage) {
			return (
				<div style={{ display: "flex", 
					flexDirection: "column", 
					width: "100vw", 
					height: "100vh", 
					alignItems: "center", 
					justifyContent: "center", 
					backgroundImage: "url('http://www.ambifi.com/assets/images/stock/smiley-low.png')",
					backgroundRepeat: "no-repeat",
					backgroundAttachment: "fixed",
					backgroundPosition: "center center",
					backgroundSize: "cover" }}>
					<h1 style={{margin:"25px", fontSize: "40pt", fontWeight: "bold", color: "whitw"}}>Thank you!</h1>
				</div>
			);
		}

		const components = [];
		const autoPlay = getConfigParam("autoPlay", true);

		if (!autoPlay) {
			document.getElementsByTagName("body")[0].style.cssText = "overflow-y:hidden";
			if (this.state.hidePlayOverlay) {
				document.getElementsByTagName("body")[0].style.cssText = "overflow-y:auto";
			}
			components.push(
				<div key="ambifi-web-player-play-verlay" className={`overlay-play${this.state.transitionPlayOverlay ? " fadeOut" : ""}${this.state.hidePlayOverlay ? " hidden" : ""}`}>
					<div style={{ display: "flex", flexDirection: "column", height: "50%", minHeight: "200px", justifyContent: "space-between", cursor: "pointer" }}>
						<div class="play-button" onClick={this.handleHidePlayOverlay}>
							<FontAwesomeIcon icon="play" />&nbsp;&nbsp;Play Inline
							</div>
						<div class="launch-new-window-button" onClick={this.handleOpenInNewTab}>
							<FontAwesomeIcon icon="far" />&nbsp;&nbsp;Play In New Tab
							</div>
						<div style={{ textAlign: "center" }}>
							<div style={{ color: "white", fontWeight: 600, fontSize: "11px", fontFamily: "'Roboto Condensed', sans-serif" }}>Powered By<br /><a href="https://www.ambifi.com"><img src="./ambifi-logo-powered-by.png" alt="AmbiFi Logo" style={{ width: "78px", height: "25px", marginLeft: "-5px" }} /></a></div>
						</div>
					</div>
				</div>
			);
		}

		components.push(<AmbifiWebPlayer key="ambifi-web-player" state={this.props.state} config={this.props.config} env={this.props.env} activities={this.props.activities} onLoad={this.handleWebPlayerOnLoad} onExit={this.handleWebPlayerOnExit} />);

		if (this.props.securityContextUri) {
			// console.log("ADD SECURITY CONTEXT IFRAME");
			components.push(<iframe key="player-security-context" title="Player security context" style={{ width: "400px", height: "400px", position:"absolute",left:-500,top:-500 }} src={this.props.securityContextUri}></iframe>);
		}

		return components;
		//}
	}
}
export default branch({
	activityName: ["activity", "name"]
}, App);
